import React from 'react';
import { Bounce, Fade } from 'react-awesome-reveal';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

import './Partner.scss';
import {
    AlipayIco,
    BankTransferIco,
    BinanceIco,
    CoinbaseIco,
    NetellerIco,
    OkcoinIco,
    SkrillIco,
    UnionPayIco,
    WechatPayIco
} from 'assets/images';

const Partner = () => {
    const { t } = useTranslation();

    const partnerInfos = [
        {
            name: 'unionPay',
            image: UnionPayIco,
            width: 80
        },
        {
            name: 'bankTransfer',
            image: BankTransferIco,
            width: 200
        },
        {
            name: 'alipay',
            image: AlipayIco,
            width: 180
        },
        {
            name: 'weChatPay',
            image: WechatPayIco,
            width: 180
        },
        {
            name: 'coinbase',
            image: CoinbaseIco,
            width: 200
        },
        {
            name: 'binance',
            image: BinanceIco,
            width: 220
        },
        {
            name: 'skrill',
            image: SkrillIco,
            width: 120
        },
        {
            name: 'okcoin',
            image: OkcoinIco,
            width: 200
        },
        {
            name: 'neteller',
            image: NetellerIco,
            width: 200
        }
    ];

    return (
        <Box className="partner">
            <Typography component="h2">
                <Fade duration={800}>{t('home.partner.title')}</Fade>
            </Typography>
            <Box className="partnerList">
                {partnerInfos.map((item, index) => (
                    <Box className="partnerItem" key={index}>
                        <Box className="partnerIco">
                            <Bounce>
                                <img src={item.image} alt="" />
                            </Bounce>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default Partner;
